import { render } from "./Starfield.vue?vue&type=template&id=2b6339ec&scoped=true"
import script from "./Starfield.vue?vue&type=script&lang=js"
export * from "./Starfield.vue?vue&type=script&lang=js"

import "./Starfield.vue?vue&type=style&index=0&id=2b6339ec&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b6339ec"],['__file',"src/Web/scripts/components/Starfield.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2b6339ec"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2b6339ec', __exports__)) {
    api.reload('2b6339ec', __exports__)
  }
  
  module.hot.accept("./Starfield.vue?vue&type=template&id=2b6339ec&scoped=true", () => {
    api.rerender('2b6339ec', render)
  })

}


export default __exports__